import React, { useState } from 'react';
import { FiltersStoreState } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { FilterStoreContext } from 'apps/sigma2-ui/src/filters-v2/lib/FilterStoreContext';

export const FilterStoreRenderer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, setState] = useState<FiltersStoreState>({
    selections: [],
  });

  return (
    <FilterStoreContext.Provider value={{ state, setState }}>
      {children}
    </FilterStoreContext.Provider>
  );
};
